<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-dialog-content>
  <p>{{'PW_MUST_HAVE1' | translate}}</p>
  <ul>
      <li>
          <strong>10</strong> {{'PW_MUST_HAVE2' | translate}} <strong>50</strong> {{'PW_MUST_HAVE3' | translate}}
      </li>
  </ul>
  <p class="subtitle">{{'PW_MUST_HAVE4' | translate}}</p>
  <ul>
      <li>
          <strong>{{'SUB_UPPER' | translate}}</strong> {{'SUB_LETTER' | translate}}
      </li>
      <li>
          <strong>{{'SUB_LOWER' | translate}}</strong> {{'SU B_LETTER' | translate}}
      </li>
      <li>
          <strong>{{'PW_UNICODE' | translate}} </strong> {{'PW_UNICODE2' | translate}}
      </li>
      <li>
          <strong>{{'SUB_NUMBER' | translate}}</strong>
      </li>
      <li>
          <strong>{{'SUB_SPECIAL' | translate}}</strong>
      </li>
  </ul>
</mat-dialog-content>
<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClose()" type="button" color="primary">{{'H_CLOSE' | translate}}</button>
</div>
